import { useLocation, useNavigate, Navigate } from "react-router-dom";
import ClientsPage from "./ClientsPage";
import OrdersPage from "./OrdersPage";
import { PageHeader } from "../components/ui-bits";
import { useT } from "../lib/i18n";

// Container for the merged "Clienti & Ordini" menu entry.
// Both children stay mounted (display:none for the inactive tab) so that
// filters, search text and unsaved form state survive tab switches.
export default function ClientsOrdersPage() {
  const loc = useLocation();
  const nav = useNavigate();
  const t = useT();
  const params = new URLSearchParams(loc.search);
  const tab = params.get("tab") === "orders" ? "orders" : "clients";

  const setTab = (t) => {
    const p = new URLSearchParams(loc.search);
    p.set("tab", t);
    nav(`/clients-orders?${p.toString()}`, { replace: false });
  };

  return (
    <div data-testid="clients-orders-page">
      <PageHeader
        eyebrow={t("clients_orders.eyebrow")}
        title={tab === "orders" ? t("orders.title") : t("clients.title")}
        description={tab === "orders" ? t("orders.desc") : t("clients.desc")}
      />
      <div className="flex gap-1 border-b mb-6" style={{ borderColor: "var(--border)" }}>
        <button
          type="button"
          data-testid="tab-clients"
          onClick={() => setTab("clients")}
          className="px-5 py-3 text-xs uppercase tracking-widest border-b-2"
          style={{
            color: tab === "clients" ? "var(--text-primary)" : "var(--text-secondary)",
            borderColor: tab === "clients" ? "var(--text-primary)" : "transparent",
          }}
        >
          {t("tab.clients")}
        </button>
        <button
          type="button"
          data-testid="tab-orders"
          onClick={() => setTab("orders")}
          className="px-5 py-3 text-xs uppercase tracking-widest border-b-2"
          style={{
            color: tab === "orders" ? "var(--text-primary)" : "var(--text-secondary)",
            borderColor: tab === "orders" ? "var(--text-primary)" : "transparent",
          }}
        >
          {t("tab.orders")}
        </button>
      </div>
      {/* Keep both mounted; toggle visibility so state persists across tabs. */}
      <div style={{ display: tab === "clients" ? "block" : "none" }}>
        <ClientsPage embedded/>
      </div>
      <div style={{ display: tab === "orders" ? "block" : "none" }}>
        <OrdersPage embedded/>
      </div>
    </div>
  );
}

// Convenience redirect components — used by <Route> for the legacy paths.
export function RedirectToClientsTab() { return <Navigate to="/clients-orders?tab=clients" replace/>; }
export function RedirectToOrdersTab() { return <Navigate to="/clients-orders?tab=orders" replace/>; }
